/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox {

    @Serenity.Decorators.registerClass()
    export class ContactFileDialog extends NoboxEntityDialog<any, any> {
        protected getFormKey() { return ContactPhotoForm.formKey; }
        protected form = new ContactPhotoForm(this.idPrefix);
        public callback = (result) => { }

        constructor() {
            super();
            var initFile = false;
            this.form.Photo.element.parent().find("ul").on("DOMNodeInserted", function () {
                if (initFile == false) {
                    initFile = true;
                    $('ul li.file-item.file-image').each(function () {
                        var elIMage = $(this).find(".thumb ");
                        $(this).find(".thumb ").removeAttr("style");
                        $(this).find(".thumb ").css("overflow", "hidden");
                        var image = elIMage.attr("href");
                        elIMage.html(`<img src="${image}" style = "height: 100%;width: auto;overflow: hidden;margin:auto;" >`);
                    });
                    initFile = false;
                }
            });
        }

        protected updateTitle(): void {
            super.updateTitle();
        }

        dialogOpen() {
            super.dialogOpen();
            $(".s-Nobox-ContactFileDialog").children("div.ui-dialog-titlebar").find("span.ui-dialog-title").text("Upload contact photo");
            Q.Router.replace("");
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();

            buttons = [];
            return buttons;
        }

        protected getDialogButtons() {
            var $this = this;
            var buttons = super.getDialogButtons();
            return [
                {
                    text: 'Upload',
                    click: () => {
                        if (this.form.Photo.value == null) {
                            Q.notifyError("please input a file");
                        } else {
                            Q.serviceCall({
                                url: "/Inbox/UploadFile/UploadContactFile",
                                request: this.form.Photo.value,
                                onSuccess: (res: any) => {
                                    if (res.IsError) {
                                        Q.notifyError(res.Error);
                                    } else {
                                        this.callback(res.Data);
                                        this.dialogClose();
                                    }
                                }
                            });
                        }
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }
    }
}